// extracted by mini-css-extract-plugin
export default {"referral-button":"referralLinksDrawer_referral-button__QroHn","form-input-block":"referralLinksDrawer_form-input-block__chWM8"};